import React from "react";
import { Link } from "react-router-dom";
import Form from "./form";
import { CREATE_ABBVIE_LMBC_HCP } from "./query";

function Create() {
    return (
        <div className="shadow p-5">
            <Link className="btn btn-outline-primary" to="/abbvie-lmbc/derm-finder">
                Back
            </Link>
            <h3 className="mb-5 mt-4">Create Dermatologist</h3>
            <Form query={CREATE_ABBVIE_LMBC_HCP} />
        </div>
    );
}

export default Create;
